import { render } from "./GetSystemModules.vue?vue&type=template&id=64acb032&scoped=true"
import script from "./GetSystemModules.vue?vue&type=script&lang=js"
export * from "./GetSystemModules.vue?vue&type=script&lang=js"

import "./GetSystemModules.vue?vue&type=style&index=0&id=64acb032&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64acb032"]])

export default __exports__